import client from 'lib/api/client'
import { BasePriceType } from './type'

export async function getBrwnieBasePrice() {
  const response = await client.get<BasePriceType[]>('/service-api/v1/price/basePrice')
  return Array.isArray(response.data) ? response.data : []
}
